const HEADERS = ['Nome', 'CEP Inicial', 'CEP Final', 'Faixa de preço'];

const LABELS = {
  TITLE: 'Inconsistência nas faixas de preço',
  DESCRIPTION: 'Revise as alterações dos ranges a seguir',
  NOT_SELECTED: 'Não selecionada'
};

export { HEADERS, LABELS };
